import { requestUrl } from '@/config/app';
import { bindBrowserVisits, createBrowserVisitRecorder } from '../../../admin/src/utils/visit-records';

export const loginVisits = createBrowserVisitRecorder({
  getToken: () => window.localStorage.getItem('token') || '',
  baseUrl: `${requestUrl.replace(/\/$/, '')}/api/v1/`,
});

export function setupLoginVisits() {
  bindBrowserVisits(loginVisits);
}
